import React, {useContext, useState} from 'react'
import {MyContext} from '../Actions/UAuth'
import Loader from "react-loader-spinner";
//import swal from 'sweetalert';
import ls from 'local-storage'
// React Notification
import { NotificationManager } from 'react-notifications'

function Login(){

    const {toggleNav,loginUser,isLoggedIn} = useContext(MyContext);
    const initialState = {
        userInfo:{
            email:'',
            password:'',
        },
        errorMsg:'',
        successMsg:'',
        errors: {},
        loading: false,
       }

    const [state,setState] = useState(initialState);

    // On change input value (email & password)
    const onChangeValue = (e) => {
        setState({
            ...state,
            userInfo:{
                ...state.userInfo,
                [e.target.name]:e.target.value
            }
        });
    }
    const handleValidation=()=>{
        let userInfo = state.userInfo;        
        let errors = {};
        let formIsValid = true;  
        if(!userInfo["email"] || userInfo["email"] ===''){
            formIsValid = false;
            errors["email"] = "Please Enter Email ID";
          }  
          if(!userInfo["password"] || userInfo["password"] ===''){
            formIsValid = false;
            errors["password"] = "Please Enter Password";
          }   
          state.errors = errors;
          return formIsValid;                        
    }
    // On Submit Login From
    const submitForm = async (event) => {
        console.log(state.loading);
        event.preventDefault();
        if(handleValidation()){
            setState({
                ...state,
                loading : true
            });
        const data = await loginUser(state.userInfo);
        if(data.success && data.token){
            setState({
                ...initialState
            });
            //localStorage.setItem('loginToken', data.token);
            ls.set('loginToken', data.token)
            NotificationManager.success('You have Successfully Login!', 'Successful!', 2000);
            await isLoggedIn();       
        }
        else{
            setState({
                ...state,
                successMsg:'',
                errorMsg:data.message,
                loading : false
            });           
        }
      }else{
        NotificationManager.error('Error while Login!', 'Error!', 2000);        
      } 
    }
    // Show Message on Error or Success
   
    if(state.errorMsg){
        NotificationManager.error(state.errorMsg, 'Error!', 2000);              
    }

    return(
      <div>  
        <div className="bg"></div>
        <div className="bg bg2"></div>
        <div className="bg bg3"></div>         
        
        { state.loading && (
            <div className="content-wrapper">  
             <div style={{ textAlign: "center" }}>
             <br></br>
             <br></br>      
             <Loader
               type="Puff"
               color="#00BFFF"
               height={600}
               width={600}
               visible={state.loading}
             /> 
           </div>
           </div>
    )}   
     { !state.loading && (   
         <div className="login-box content_login_registr">         
          <div className="login-logo">
          <img src={`${process.env.PUBLIC_URL}/asset/images/wms.png`} className="faa-pulse animated" width="100" height="80" alt="logo"/>
          <h1>Login</h1>
            </div>
            <div className="login-box-body">
            <form  onSubmit={submitForm} noValidate autoComplete="off">
                <div className="form-group has-feedback">
                    <label>Email</label>
                    <input name="email" type="email" className="form-control" required placeholder="Enter your email" value={state.userInfo.email} onChange={onChangeValue} />
                    <span className="glyphicon glyphicon-envelope form-control-feedback"></span>
                    <span className="text-red">{state.errors["email"]}</span>
                </div>
                <div className="form-group has-feedback">
                    <label>Password</label>
                    <input name="password" type="password" className="form-control" required placeholder="Enter your password" value={state.userInfo.password} onChange={onChangeValue} />
                    <span className="glyphicon glyphicon-lock form-control-feedback"></span>
                    <span className="text-red">{state.errors["password"]}</span>
                </div>
                <div className="form-group">
                    <button type="submit" className="btn btn-primary btn-block btn-flat" disabled={state.loading}>{state.loading && (
            <i
              className="fa fa-refresh fa-spin"
              style={{ marginRight: "5px" }}
            />
          )}
          {state.loading && <span>Loading Login Process</span>}
          {!state.loading && <span>Login</span>}</button>
                </div>
            </form>
            
            <div className="form-group">
                <button className="btn btn-primary btn-block btn-flat" onClick={toggleNav}>Register</button>
            </div>
            </div>
           
        </div>
         )}
        <footer className="main-footer" style={{marginLeft: '0px',position: 'fixed',bottom: '0px',width:'100%'}}>
        <div className="pull-right hidden-xs">
            <b>Last Updated</b> {process.env.REACT_APP_API_UPDATED_DATE}
            </div>
            <strong>Designed & Developed By  <a href="http://stocksgems.in">Dilip Gauswami </a>.</strong>Gandhinagar(Gujarat)</footer>        
        </div>
        
    );
}

export default Login;
